module.exports = __webpack_public_path__ + "static/media/spinner.26ef8bb4.gif";